export class LogicalType {
    type = 'LogicalType';
    name;
    version;
    constructor(name, version) {
        this.name = name;
        this.version = version;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG9naWNhbFR5cGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL3R5cGVzL0xvZ2ljYWxUeXBlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sT0FBTyxXQUFXO0lBQ2IsSUFBSSxHQUFHLGFBQWEsQ0FBQTtJQUNwQixJQUFJLENBQVE7SUFDWixPQUFPLENBQVE7SUFFeEIsWUFBWSxJQUFZLEVBQUUsT0FBZTtRQUN2QyxJQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQTtRQUNoQixJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQTtJQUN4QixDQUFDO0NBQ0YifQ==